module.exports = __webpack_public_path__ + "img/i-beam.09572eea.svg";